import React, { Suspense, useEffect } from "react";
import { useLoader } from "@react-three/fiber";
import {OrbitControls, Stars} from '@react-three/drei'
import { TextureLoader } from "three";
import EarthDay from '../../images/earthDay10k.jpg';
import EarthNight from '../../images/earthNight10k.jpg';
import { MeshPhongMaterial } from "three";
import * as THREE from "three";
import { useState } from "react";
import { data_15000 } from "./cities15000";
import {small} from '../../small-city'
import { PerspectiveCamera } from "@react-three/drei";
import {post} from "../../utils/API";
import { API_URL } from "../../utils/API";

function EarthFiber({metadatas, setNodeData, setRendering}) {
    const [colorMap, nightMap] = useLoader(TextureLoader, [EarthDay, EarthNight])
    const [map, setMap] = useState(nightMap)
    

function curve2(source,destination) { //lat,long
  if (source === undefined || destination === undefined) {
    return
  }
  let p1 = updatePlane(parseFloat(source["lat"]), parseFloat(source["long"]));   //source["lat"],source["long"
  let p2 = updatePlane(parseFloat(destination["lat"]), parseFloat(destination["long"])); //dest["Tompkins County"]["lat"],dest["Tompkins County"]["long"]   //destination["lat"],destination["long"]

if (isNaN(p1.x)) {
  return;
}
  

  if (p1.x === NaN || p1.y ===NaN || p1.z === NaN) {
    return;
  }

  let v1 = new THREE.Vector3(p1.x,p1.y,p1.z);
  let v2 = new THREE.Vector3(p2.x,p2.y,p2.z);

  let a = p2.x - p1.x;
  let b = p2.y - p2.y;
  let c = p2.z - p2.z;
  let distance = Math.sqrt(a*a + b*b + c*c);
 
  let points = [];
  var min = 0.001;
  var max = 0.1;
  if (distance == 0) {
    return;
  }
  if (distance <= 0.09) {
    max = 0.01;
  }
  let randomHeight = Math.random() * (max - min) + min;
  //for (let i = 0; i <= 1000; i++) {
  //    let p = new THREE.Vector3().lerpVectors(v1,v2,i/1000);
  //    p.normalize();
  //    p.multiplyScalar(1 + (randomHeight)*Math.sin(Math.PI*i/1000)); //0.1
  //    points.push(p);
  //}
  for (let i = 0; i <= 1000; i++) {
    let p = new THREE.Vector3().lerpVectors(v1,v2,i/1000);
    p.normalize();
    //p.multiplyScalar(1 + (randomHeight)*Math.sin(Math.PI*i/10)); //0.1
    p.multiplyScalar(1 + (0.1*distance)*Math.sin(Math.PI*i/1000)); //0.1
    points.push(p);
}

  let path = new THREE.CatmullRomCurve3(points);
  console.log(path)
  return path
}


    
function convert(lat, lon) {


    let phi   = (90-lat)*(Math.PI/180);
    let theta = (lon+180)*(Math.PI/180);
    let x = -((1) * Math.sin(phi)*Math.cos(theta));
    let z = ((1) * Math.sin(phi)*Math.sin(theta));
    let y = ((1) * Math.cos(phi));

    return [x, y, z]
}

   
    function curve(src_latitude, src_longitude, dest_latitude, dest_longitude, src_name, dest_name) { //lat,long
      if (src_latitude === dest_latitude && src_longitude === dest_longitude) {
        return null
      }

      // if (source === undefined || destination === undefined) {
      //   return
      // }
      // let p1 = updatePlane(parseFloat(source["lat"]), parseFloat(source["long"]));   //source["lat"],source["long"
      // let p2 = updatePlane(parseFloat(destination["lat"]), parseFloat(destination["long"])); //dest["Tompkins County"]["lat"],dest["Tompkins County"]["long"]   //destination["lat"],destination["long"]
      let p1 = updatePlane(src_latitude, src_longitude);   //source["lat"],source["long"
      let p2 = updatePlane(dest_latitude, dest_longitude); //dest["Tompkins County"]["lat"],dest["Tompkins County"]["long"]   //destination["lat"],destination["long"]

      if (isNaN(p1.x)) {
        return;
      }
        
    
        if (p1.x === NaN || p1.y ===NaN || p1.z === NaN) {
          return;
        }
    
        let v1 = new THREE.Vector3(p1.x,p1.y,p1.z);
        let v2 = new THREE.Vector3(p2.x,p2.y,p2.z);
    
        let a = p2.x - p1.x;
        let b = p2.y - p2.y;
        let c = p2.z - p2.z;
        let distance = Math.sqrt(a*a + b*b + c*c);
       
        let points = [];
        var min = 0.001;
        var max = 0.1;
        if (distance == 0) {
          return;
        }
        if (distance <= 0.09) {
          max = 0.01;
        }

        let randomHeight = Math.random() * (max - min) + min;
        for (let i = 0; i <= 1000; i++) {
          let p = new THREE.Vector3().lerpVectors(v1,v2,i/1000);
          p.normalize();
          p.multiplyScalar(1 + (randomHeight)*Math.sin(Math.PI*i/1000)); //0.1
          //p.multiplyScalar(1 + (0.1*distance)*Math.sin(Math.PI*i/1000)); //0.1
          points.push(p);
        }
    
        let path = new THREE.CatmullRomCurve3(points);
        return path
    }

    function updatePlane(lat,long) {
        let phi   = (90-lat)*(Math.PI/180);
        let theta = (long+180)*(Math.PI/180);
        let x = -((1) * Math.sin(phi)*Math.cos(theta));
        let z = ((1) * Math.sin(phi)*Math.sin(theta));
        let y = ((1) * Math.cos(phi));
        return {x,y,z};
    
    }

    async function getNodeInfo(node) {
      //query
      //connectionString
      let response = await post(`${API_URL}/get-node-info`, {...metadatas.sql, node: node.name})
      setNodeData(response)
    }
    const tubeMaterial = new THREE.ShaderMaterial({
      uniforms: {
        color1: {
          value: new THREE.Color("#0000FF")
        },
        color2: {
          value: new THREE.Color("#FF0000")
        }
      },
      vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
        }
      `,
      fragmentShader: `
        uniform vec3 color1;
        uniform vec3 color2;
        varying vec2 vUv;
        
        void main() {
          gl_FragColor = vec4(mix(color1,color2,vUv.x), 1.0);
        }
      `
    });

    function tubeMaterialFunction(src, dest) {
      return new THREE.ShaderMaterial({
        uniforms: {
          color1: {
            value: new THREE.Color(src)
          },
          color2: {
            value: new THREE.Color(dest)
          }
        },
        vertexShader: `
          varying vec2 vUv;
          void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }
        `,
        fragmentShader: `
          uniform vec3 color1;
          uniform vec3 color2;
          varying vec2 vUv;
          
          void main() {
            gl_FragColor = vec4(mix(color1,color2,vUv.x), 1.0);
          }
        `
      })
    }

    const fragmentShader = `
    uniform vec3 color1;
    uniform vec3 color2;
    varying vec2 vUv;
    
    void main() {
      gl_FragColor = vec4(mix(color1,color2,vUv.x), 1.0);
    }
  `

  const vertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
  }
`

const uniform = (color1, color2) => {
  return new THREE.ShaderMaterial({
    uniforms: {
      color1: {
        value: new THREE.Color(color1)
      },
      color2: {
        value: new THREE.Color("#FF0000")
      }
    }
})
}

  const nodeMaterial = new THREE.MeshPhongMaterial({color:0xff0000});
  const nodeGeometry = new THREE.SphereGeometry(0.0025, 32, 16)
/*
          <mesh>
              <tubeGeometry path={curve(cities[1], cities[0])} tubularSegments={70} radius={0.02} radialSegments={50} closed={false} />
              <shaderMaterial fragmentShader={fragmentShader} vertexShader={vertexShader}></shaderMaterial>
            </mesh>
*/
/*
    <mesh position={[-0.619573419700504, 0.5836691344087064, -0.5248419944509153]} onClick={() => console.log("There")}>
                <sphereGeometry args={[0.0025, 32, 16]} />
                <meshPhongMaterial color="red"/>
            </mesh>
*/

// **Important**     <shaderMaterial fragmentShader={fragmentShader} vertexShader={vertexShader} uniforms={uniforms}></shaderMaterial> 
// **Important**   <meshPhongMaterial color="red"/>
// **Important**      <sphereGeometry args={[0.0025, 32, 16]} />
  useEffect(() => {
    if (!metadatas) {
      setRendering(false)
    }
  })

    return (
        <>
            <ambientLight intensity={3}/>
            <pointLight intensity={1} position={[5, 3, 2]}/>
            <Stars/>
            <mesh>
                <sphereGeometry args={[1,50,50]}/>
                <meshPhongMaterial map={map}/>
            </mesh>

          <Suspense fallback={null}>

          {metadatas ? metadatas.edges.map((item) => {
      
      return (
        <>
          <mesh material={tubeMaterial}> {/**tubeMaterialFunction(item.src_color, item.dest_color) */}
          <tubeGeometry args={[curve(item.source.latitude, item.source.longitude, item.destination.latitude, item.destination.longitude), 200, 0.0005, 8, false]} />
       
          </mesh>
        </>
    )


  }) : null}
          </Suspense>
            

            <Suspense fallback={null}>
            {metadatas !== null ? metadatas.nodes.length === 0 ? setRendering(false) : null  : null}
            {metadatas ? metadatas.nodes.map((node, index) => {
              if (index === metadatas.nodes.length - 1) {setRendering(false)}
return (
  <>
  <mesh material={nodeMaterial} geometry={nodeGeometry} position={convert(node.latitude, node.longitude)} onClick={() => getNodeInfo(node)}>
  </mesh> 
</>
)
})
: null} 
            </Suspense>



  

            <PerspectiveCamera
              position={[0,20,20]}
              aspect={window.innerWidth / window.innerHeight}
              fov={80}
              near={0.01}
              far={1000}
              zoom={5}
            />
            <OrbitControls enableZoom={true} enablePan={false} enableRotate={true} zoomSpeed={1} panSpeed={0.5} rotateSpeed={0.4} maxDistance={10} minDistance={1.2} makeDefault>
          
            </OrbitControls>
        </>
    )
}


/*
return (
  <>
  <mesh material={nodeMaterial} geometry={nodeGeometry} position={convert(node.latitude, node.longitude)} onClick={() => getNodeInfo(node)}>
  </mesh> 
</>
)
})
: null} 
            </Suspense>



  

            <PerspectiveCamera
              position={[0,20,20]}
              aspect={window.innerWidth / window.innerHeight}
              fov={80}
              near={0.01}
              far={1000}
              zoom={5}
            />
            <OrbitControls enableZoom={true} enablePan={false} enableRotate={true} zoomSpeed={1} panSpeed={0.5} rotateSpeed={0.4} maxDistance={10} minDistance={1.2} makeDefault>
          
            </OrbitControls>
        </>
    )
}
*/
export default React.memo(EarthFiber)
